export default function formValidatePassword() {
  return {
    pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}$/,
    message: 'Senha inválida',
  };
}
